export enum SLHeaders {
  SESSION_ID = 'X-DAPX-SESSION-ID',
  CORRELATION_ID = 'X-DAPX-CORRELATION-ID',
  TRANSACTION_ID = 'X-DAPX-TRANSACTION-ID',
  PARENT_TRANSACTION_ID = 'X-DAPX-PARENT-TRANSACTION-ID',
  REQUEST_ID = 'X-DAPX-REQUEST-ID',
  APP_ORIGIN = 'X-APP-ORIGIN',
  APP_VERSION = 'X-APP-VERSION',
  LOCALE = 'X-LOCALE',
  CURRENCY = 'X-CURRENCY',
  VISITOR_ORIGIN = 'X-DAPX-ORIGIN',
}

export enum HttpMethod {
  HEAD = 'HEAD',
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  OPTIONS = 'OPTIONS',
  DELETE = 'DELETE',
}
